import axioInstance from "../../custom_utilities/AxiosInstance/axiosInstance";

const AITS_TESTLIST_URL =
  "https://learning.motion.ac.in/motioneducation/api/v1/practice_testlist";
  
  const AITS_SYLLABUS_URL =
  "https://learning.motion.ac.in/motioneducation/api/v1/get/aits/syllabus";


const aitsApi = {
  getAitsTestList: async ({
    paperType,
    plannerId,
    plannerTestType,
    year,
    format,
    categoryId,
    page = 1,
  }) => {
    const res = await axioInstance.get(
      `${AITS_TESTLIST_URL}?paper_type=${paperType}&planner_id=${plannerId}&planner_test_type=${plannerTestType}&year=${year}&format=${format}&category_id=${categoryId}&page=${page}`
    );
    return res.data;
  },

   getAitsSyllabus: async ({ paperId, plannerId }) => {
    const res = await axioInstance.get(
      `${AITS_SYLLABUS_URL}?paper_id=${paperId}&planner_id=${plannerId}`
    );
    return res.data;
  },
};

export default aitsApi;
